import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import type { PricingMode } from "@/gql/graphql";
import { getPricingModeColor, getPricingModeLabel } from "@/lib/utils/pricing-utils";

interface PricingModeBadgeProps {
  mode: PricingMode;
  variant?: "default" | "secondary" | "destructive" | "outline";
  size?: "sm" | "default" | "lg";
}

export function PricingModeBadge({
  mode,
  variant = "secondary",
  size = "default",
}: PricingModeBadgeProps) {
  const { t } = useTranslation("services");
  const label = getPricingModeLabel(mode, t);
  const colorClass = getPricingModeColor(mode);

  return (
    <Badge
      variant={variant}
      className={`${colorClass} border-0 font-medium ${
        size === "sm"
          ? "text-xs px-2 py-0.5"
          : size === "lg"
            ? "text-sm px-3 py-1"
            : "text-xs px-2 py-1"
      }`}
    >
      {label}
    </Badge>
  );
}
